{
  "failed_fetch_profile": "Failed to fetch profile data",
  "failed_update_profile": "Failed to update profile data",
  "account_information": "Account Information",
  "language": "Language",
  "member_since": "Member Since",
  "account_status": "Account Status",
  "profile_complete": "Profile Complete",
  "delete_account": "Delete Account",
  "delete_user_account": "Delete User Account",
  "delete_account_warning": "Once you delete your account, there is no going back. Please be certain.",
  "delete_user_warning": "This will permanently delete this user's account. This action cannot be undone.",
  "delete_user": "Delete User",
  "really_delete": "Really Delete? ({seconds})",
  "edit_information": "Edit Information",
  "edit_profile": "Edit Profile",
  "choose_language": "Choose Language",
  "security": "Security",
  "security_coming_soon": "Security settings coming soon",
  "delete_confirmation": "Are you sure you want to delete your user account?",
  "delete_warning": "This action cannot be undone.",
  "email": "Email",
  "password": "Password",
  "current_password": "Current Password",
  "new_password": "New Password",
  "confirm_new_password": "Confirm New Password",
  "change_password": "Change Password",
  "password_changed_successfully": "Password changed successfully",
  "birth_year": "Birth Year",
  "date_of_birth": "Date of Birth",
  "date_of_birth_help": "Required for age-restricted competitions",
  "profile_image": "Profile Image",
  "upload_profile_image": "Upload Profile Image",
  "change_profile_image": "Change Profile Image",
  "remove_profile_image": "Remove Profile Image",
  "profile_image_uploaded": "Profile image uploaded successfully",
  "profile_image_removed": "Profile image removed successfully",
  "upload_image_hint": "Click or drag and drop an image here. Max 5MB. JPEG, PNG, or WebP only.",
  "uploading_image": "Uploading image...",
  "removing_image": "Removing image...",
  "failed_to_upload_image": "Failed to upload profile image",
  "failed_to_remove_image": "Failed to remove profile image",
  "invalid_file_type": "Invalid file type. Only JPEG, PNG, and WebP images are allowed",
  "file_size_exceeded": "File size exceeds maximum limit of 5MB",
  "preferred_units": "Preferred Units",
  "preferred_units_help": "Choose whether you want to see fairway lengths in meters or yards",
  "preferences": {
    "title": "Preferences",
    "track_statistics": "Track round statistics",
    "track_statistics_description": "Collect detailed statistics (fairway, green, putts, etc.) from your rounds",
    "prompt_course_conditions": "Ask for course conditions after round",
    "prompt_course_conditions_description": "When you finish a round, you'll be prompted to enter course conditions (weather, green speed, etc.)",
    "statsCollection": {
      "perStat": {
        "putts": "Putts",
        "chips": "Chips",
        "bunkerShots": "Bunker shots",
        "penaltyStrokes": "Penalty strokes",
        "firstPutt": "First putt",
        "holedPutt": "Holed putt",
        "gir": "Green in regulation",
        "fir": "Fairway in regulation"
      }
    }
  },
  "units": {
    "metric": "Meters",
    "imperial": "Yards"
  },
  "confirm_remove_profile_image": "Are you sure you want to remove the profile picture?",
  "crop_profile_image": "Crop profile picture",
  "zoom": "Zoom",
  "golfid_fields_info": "Your account is linked to GolfID. Name, gender, handicap, and date of birth are automatically updated from the Finnish Golf Union registry.",
  "golf_id": {
    "section_title": "Link Suomi Golf ID",
    "section_title_linked": "Suomi Golf ID",
    "linked": "Linked",
    "link_button": "Link Suomi Golf ID",
    "username_label": "Suomi Golf ID username",
    "username_placeholder": "Suomi Golf ID or email address",
    "password_label": "Password",
    "password_placeholder": "Password",
    "linking": "Linking...",
    "link_success": "Golf ID linked successfully",
    "error_invalid_credentials": "Invalid username or password",
    "error_already_linked": "Account is already linked to a Golf ID",
    "error_taken": "This Golf ID is already linked to another account",
    "error_unavailable": "Golf ID service is unavailable",
    "error_challenge": "Golf ID requires additional verification",
    "description": "By linking your accounts you get an up-to-date handicap and can submit scores to the official handicap calculation.",
    "privacy_notice": "Your Suomi Golf ID credentials are used only for linking and are not stored.",
    "forgot_password": "Forgot password?",
    "error_invalid_format": "The ID you entered is not a Suomi Golf ID. You can find your Suomi Golf ID in the settings of the eBirdie app."
  },
  "payment_history": {
    "title": "Payment History",
    "no_payments": "No payments",
    "load_more": "Load more",
    "competition_fee": "Competition fee",
    "green_fee": "Green fee",
    "load_failed": "Failed to load payment history"
  },
  "round_settings": {
    "private_round": "Private round",
    "private_round_description": "A private round is not visible to your friends"
  },
  "feedback": {
    "row_label": "Send feedback to the developer",
    "modal_title": "Feedback Form",
    "message_placeholder": "Write your feedback to the service developer",
    "device_section_title": "My device",
    "device_apple": "Apple (iOS)",
    "device_android": "Android",
    "device_desktop": "Desktop",
    "wants_contact_label": "I can be contacted",
    "submit": "Submit",
    "sending": "Sending",
    "cancel": "Cancel",
    "success": "Feedback sent",
    "error": "Failed to send feedback. Please try again.",
    "wants_contact_helper": "Your contact information will only be used to respond to your feedback.",
    "images": {
      "label": "Attach images (optional)",
      "optional_suffix": "(optional)",
      "cta_mobile": "Add images",
      "cta_desktop": "Drag images here or browse",
      "limit": "Max 3 images, 5 MB / image",
      "errors": {
        "too_large": "Image is too large (max 5 MB)",
        "wrong_format": "Supported formats: JPEG, PNG, WEBP",
        "too_many": "You can add a maximum of 3 images"
      },
      "remove_aria": "Remove image"
    }
  },
  "email_change": {
    "title": "Change email address",
    "description": "Your current address is <strong>{{email}}</strong>. We will send a confirmation link to the new address — the address will only change once you confirm it.",
    "new_email": "New email address",
    "submit": "Send confirmation link",
    "confirmation_sent_to": "Confirmation link sent to <strong>{{email}}</strong>.",
    "confirmation_sent_info": "Your email address will change once you open the link in the message. The link is valid for 24 hours.",
    "relogin_required": "Sign out and sign back in with your Google or Apple account, after which you can safely change your email address."
  }
}
